export default {
  SPACE: "486fbuk7vhzs",
  ACCESS_TOKEN:
    "ef73aac58d415790712277bef9edecfe0c0518ed56c3203202fbfafaeae2eb6b",
  COUPON_ENTRY_ID: "7G1cnvMG2KFSb668Hvif5r",
  CONTENT_ENTRY_ID: "2ew4O7Gu0tMZnlE3ka1Rta",
};
